import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Terminal } from "lucide-react"

const commands = [
  { command: "/start", description: "Start the bot and show the main menu", access: "All users" },
  { command: "/help", description: "Show help and available commands", access: "All users" },
  { command: "/status", description: "Check your account status and subscription", access: "All users" },
  { command: "/buy", description: "View available plans and purchase a subscription", access: "All users" },
  { command: "/configs", description: "View and manage your VPN configurations", access: "All users" },
  { command: "/servers", description: "List available VPN servers", access: "All users" },
  { command: "/connect", description: "Quick connect to the best available server", access: "All users" },
  { command: "/profile", description: "View and edit your profile settings", access: "All users" },
  { command: "/admin", description: "Open the admin panel (admin only)", access: "Admins" },
  { command: "/broadcast", description: "Send a message to all users (admin only)", access: "Admins" },
  { command: "/stats", description: "View bot usage statistics (admin only)", access: "Admins" },
  { command: "/panel", description: "Manage the customer panel settings (admin only)", access: "Admins" },
]

export default function CommandsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Commands</h1>
        <p className="text-muted-foreground">Available bot commands</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {commands.map((cmd) => (
          <Card key={cmd.command}>
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between">
                <CardTitle className="flex items-center gap-2 text-base font-mono">
                  <Terminal className="h-4 w-4" />
                  {cmd.command}
                </CardTitle>
                <Badge variant={cmd.access === "Admins" ? "destructive" : "secondary"}>
                  {cmd.access}
                </Badge>
              </div>
              <CardDescription>{cmd.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  )
}
